import { Component, AfterViewInit, ChangeDetectorRef, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, Input } from '@angular/core';
import * as L from 'leaflet';
import { bikeIcon, currentLocationIcon, pluviometerIcon, restrictionIcon, trashIcon } from '../../constants/icons.constant';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BadgeModule } from 'primeng/badge';
import { Subscription } from 'rxjs';
import { TabMenuModule } from 'primeng/tabmenu';
import { LoaderService } from '../../services/loader.service';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TrashContainers } from '../../constants/trash-containers';
import { getCurrentLocationPopUp } from '../../constants/popup.function';

@Component({
  selector: 'app-map-preview',
  standalone: true,
  imports: [CommonModule, DialogModule, RouterModule, HttpClientModule, BadgeModule, TabMenuModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './map-preview.component.html'
})
export class MapPreviewComponent implements AfterViewInit, OnDestroy {

  @Input()
  public mapId!: string;

  @Input()
  public mapInfo!: any;

  private _map!: L.Map;
  private readonly _baseMapURl: string = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png';

  private _trashMarkers: L.Marker[] = [];
  private _geoJsonRestrictionLayer: any;
  private _geoJsonBikewayLayer: any;
  public _currentLocationMarker!: L.Marker;

  public isVisible: boolean = false;

  private _subscription: Subscription;

  constructor(private config: DynamicDialogConfig,
    private _loaderService: LoaderService,
    private _cdr: ChangeDetectorRef) {
    this._subscription = new Subscription();
    this.mapInfo = config.data.mapInfo;
    this.mapId = config.data.mapId;
  }

  ngAfterViewInit() {
    this._initializeMap();
    setTimeout(() => {
      console.log(this._map);
      console.log(this.mapId);
      
      this._markMap();
    });
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  private _initializeMap(): void {
    this._map = new L.Map(this.mapId, { zoomAnimation: true, minZoom: 10 });
    this._map.locate({ setView: false, enableHighAccuracy: true });
    this._map.on('locationfound', (e: any) => this._onLocationFound(e));

    L.tileLayer(this._baseMapURl, { attribution: '© OpenStreetMap' }).addTo(this._map);
  }

  private _onLocationFound(e: any): void {
    const cbbaBounds = {
      north: -17.2600,
      south: -17.5100,
      east: -66.1200,
      west: -66.2600
    };

    const isInCochabamba = e.latlng.lat <= cbbaBounds.north &&
      e.latlng.lat >= cbbaBounds.south &&
      e.latlng.lng <= cbbaBounds.east &&
      e.latlng.lng >= cbbaBounds.west;

    if (isInCochabamba) {
      this._currentLocationMarker = L.marker([e.latlng.lat, e.latlng.lng]);
      this._currentLocationMarker.setIcon(currentLocationIcon);
      this._currentLocationMarker.addTo(this._map).bindPopup(this._getPopUpContent('currentLocation'));
      this._currentLocationMarker.openPopup();
    } else {
      this._setCbbaLocation();
    }
  }

  private _getPopUpContent(type: string): L.Popup {
    const popUp: L.Popup = L.popup();
    let content: string = '';

    switch (type) {
      case 'currentLocation':
        content = getCurrentLocationPopUp();
        break;
    }

    popUp.setContent(content);
    return popUp;
  }

  private _setCbbaLocation() {
    const defaultLat = -17.387962727660373;
    const defaultLong = -66.1557113167231;

    this._map.setView(new L.LatLng(defaultLat, defaultLong), 13);
  }

  //Routes
  private _fillMapRoutes(route: string): void {
    switch (route) {
      case 'bikeway':
        this._loadGeoJson('bikeway', this._geoJsonBikewayLayer);
        break;

      case 'restriction':
        this._loadGeoJsonPolyline('restriction', this._geoJsonRestrictionLayer, 'Restricción vehicular');
        break;
    }
  }

  private _loadGeoJson(fileName: string, layerItem: any, color: string = '#ae1857'): void {
    this._loaderService.show();
    const filePath = this._getGeoJsonFilePath(fileName);

    if (filePath) {
      fetch(filePath)
        .then(response => response.json())
        .then(geoJson => {
          layerItem = L.geoJSON(geoJson, { style: { color: color } });
          this.showHideRoute(layerItem);
          this._loaderService.hide();
        })
        .catch((error: any) => {
          this._loaderService.hide();
          console.error('Error loading GeoJSON file:', error)
        });
    } else {
      this._loaderService.hide();
      console.error('Invalid GeoJSON file name:', fileName);
    }
  }

  private _getGeoJsonFilePath(fileName: string): string | null {
    switch (fileName) {
      case 'bikeway':
        return 'assets/geojson/bikeway.geojson';

      case 'restriction':
        return 'assets/geojson/restriction.geojson';

      default:
        return null;
    }
  }

  public showHideRoute(layerItem: any) {
    if (this._map.hasLayer(layerItem)) {
      this._map.removeLayer(layerItem);
    } else {
      this._map.addLayer(layerItem);
      this._map.fitBounds(layerItem.getBounds());
    }
  }

  private _loadGeoJsonPolyline(fileName: string, layerItem: any, text?: string) {
    this._loaderService.show();
    const filePath = this._getGeoJsonFilePath(fileName);

    if (filePath) {
      fetch(filePath)
        .then(response => response.json())
        .then(geoJson => {
          const polygonCoordinates = [...geoJson.features[0].geometry.coordinates, geoJson.features[0].geometry.coordinates[0]];
          const polygonGeoJson: any = {
            type: "FeatureCollection",
            features: [{
              type: "Feature",
              properties: {
              },
              geometry: {
                type: "Polygon",
                coordinates: [polygonCoordinates]
              }
            }]
          };

          layerItem = L.geoJSON(
            polygonGeoJson, {
            style: geoJson.features[0].properties
          });

          if (text) {
            layerItem.bindTooltip(text).openTooltip();
          }

          this.showHideRoute(layerItem);
          this._loaderService.hide();
        })
        .catch((error: any) => {
          this._loaderService.hide();
          console.error('Error loading GeoJSON file:', error)
        });
    } else {
      this._loaderService.hide();
      console.error('Invalid GeoJSON file name:', fileName);
    }
  }

  // Markers
  private async _fillMapLocations(location: string): Promise<void> {
    switch (location) {
      case 'trash':
        this._trashMarkers = this._generateMarker('trash');
        this._markLocations(this._trashMarkers, 'trash');
        break;
    }
  }

  private _markLocations(markerList: L.Marker[], type: any): void {
    let icon: L.Icon<any> = this._getIcon(type);

    markerList.forEach((marker: L.Marker) => {
      marker.setIcon(icon);
      marker.addTo(this._map);
    });
  }

  private _generateMarker(type: string, hasPopUp: boolean = true): L.Marker<any>[] {
    let list: L.Marker<any>[] = [];
    let elementList = this._getList(type);

    elementList.forEach((element: any) => {
      let marker = new L.Marker([element.location.coords.lat, element.location.coords.lng]);

      list.push(marker);
    });

    return list;
  }

  // Utils
  private _getList(type: string): any[] {
    let elementList: any[] = [];

    switch (type) {
      case 'trash':
        elementList = TrashContainers;
        break;
    }

    return elementList;
  }

  private _getIcon(sensorType: string): L.Icon<any> {
    let icon: L.Icon<any> = new L.Icon({});

    switch (sensorType) {
      case 'pluviometer':
        icon = pluviometerIcon;
        break;

      case 'trash':
        icon = trashIcon;
        break;

      case 'bikeway':
        icon = bikeIcon;
        break;

      case 'restriction':
        icon = restrictionIcon;
        break;
    }

    return icon;
  }

  public closeDialog() {
    this.isVisible = !this.isVisible;
    this._cdr.detectChanges();
  }

  private _markMap() {
    if (this.mapInfo?.topics?.geojson?.length > 0) {
      switch (this.mapInfo.topics.geojson[0]) {
        case 'restriction':
          this._fillMapRoutes(this.mapInfo.topics.geojson[0]);
          break;

        case 'bikeway':
          this._fillMapRoutes(this.mapInfo.topics.geojson[0]);
          break;
      }
    }

    if (this.mapInfo?.topics?.location?.length > 0) {
      switch (this.mapInfo.topics.location[0]) {
        case 'trash':
          this._fillMapLocations(this.mapInfo.topics.location[0]);
          break;
      }
    }
  }
}